import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { locationShape, routerShape } from 'react-router/lib/PropTypes';

import CustomerActions from '../../actions/CustomerActions';
import ModalActions from '../../actions/ModalActions';

import { GlobalModals } from '../../constants/AppConstants';

import connectToStores from '../../helpers/connectToStores';

import t from '../../lib/I18n';

import PasswordAndPreferencesForm from '../../records/customer/PasswordAndPreferencesForm';
import FeatureFlagStore from '../../stores/FeatureFlagStore';

import AccountHeader from '../account/AccountHeader';
import Breadcrumb from '../account/Breadcrumb';
import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import FormComponent from '../form/FormComponent';
import PhoneNumber from '../payment/PhoneNumber';
import CustomerPassword from '../customer/Password';
import Icon from '../general/Icon';
import PrefsTable from '../customer/marketingPrefs/PrefsTable';
import { PrivacyPolicyLink } from '../customer/SignupTAndCs';
import Row from 'react-bootstrap/lib/Row';

export class SetPasswordAndPreferences extends FormComponent {
    static propTypes = {
        enableEmailMarketing: PropTypes.bool,
        enableSmsMarketing: PropTypes.bool,
        location: locationShape.isRequired,
        params: PropTypes.object.isRequired,
        router: routerShape.isRequired
    };

    static defaultProps = {
        enableEmailMarketing: true,
        enableSmsMarketing: true
    };

    state = {
        form: new PasswordAndPreferencesForm(),
        loading: false,
        submitted: false
    };

    _handleFieldChange = (field, value) => {
        this.setState({ form: this.state.form.set(field, value), submitted: false });
    };

    _handleSubmit = async () => {
        const { form } = this.state;

        if (!form.isComplete()) {
            return;
        }

        this.setState({ loading: true, submitted: true });

        const { params: { token }, router } = this.props;

        try {
            await CustomerActions.setPasswordAndPreferences(token, form);
            this.setState({ loading: false });
            ModalActions.open(GlobalModals.CONFIRM, {
                title: 'login.setPasswordAndPreferences.modal.title',
                message: 'login.setPasswordAndPreferences.modal.success.message',
                hideClose: true,
                onConfirm: () => router.push('/'),
            });
        } catch (error) {
            console.error(error);
            this.setState({ loading: false });
            ModalActions.open(GlobalModals.ERROR, {
                title: 'login.setPasswordAndPreferences.modal.title',
                message: 'login.setPasswordAndPreferences.modal.error.message'
            });
        }
    };

    _renderPasswordForm() {
        const {form, submitted} = this.state;

        return (
            <div className="margin-top--sm margin-bottom--sm">
                <p>{ t('login.resetPassword.help') }</p>

                <Row>
                    <Col xs={12}>
                        <CustomerPassword
                            form={form}
                            field="password"
                            onChange={this._handleFieldChange}
                            visited={submitted}
                            showPasswordIcon
                            showPasswordHints
                        />
                    </Col>
                </Row>
            </div>
        );
    }

    _renderPreferencesForm() {
        const { enableEmailMarketing, enableSmsMarketing } = this.props;
        const { form, submitted } = this.state;
        const needsToAddPhoneNumber = form.get('preferences').isSomeSmsPrefSetToTrue();

        return (
            <Fragment>
                <p>
                    <FormattedHTMLMessage
                        message="preference-centre.intro"
                        privacyPolicy={ <PrivacyPolicyLink /> }
                    />
                </p>

                <div className="margin-top--sm margin-bottom--sm border--bottom">
                    <PrefsTable
                        enableEmailMarketing={ enableEmailMarketing }
                        enableSmsMarketing={ enableSmsMarketing }
                        form={ form.get('preferences') }
                        isOver16
                        onChange={ this._handleFieldChange }
                    />

                    { needsToAddPhoneNumber &&
                        <PhoneNumber
                            form={ form }
                            field="telephoneNumber"
                            onChange={ this._handleFieldChange }
                            visited={ submitted }
                            required
                        />
                    }
                </div>
            </Fragment>
        );
    }

    render () {
        const { form, loading } = this.state;

        return (
            <Row ref={ this.captureFormRef } className="padding--horiz">
                <Breadcrumb pageName="Set Password and Preferences" />

                <div className="account-container clearfix">
                    <Col md={ 8 } mdOffset={ 2 } className="account margin-bottom">
                        <div className="set-password-and-preferences__header-wrapper margin-top margin-bottom">
                            <AccountHeader>{ t('login.setPasswordAndPreferences.heading') }</AccountHeader>
                        </div>

                        { this._renderPasswordForm() }
                        { this._renderPreferencesForm() }

                        <Button bsStyle="primary"
                                onClick={ this._handleSubmit }
                                disabled={ !form.isComplete() || loading }
                                className="btn-lg pull-right select">
                            { loading ? <Icon icon="spinner" className="otrl-spin" /> : t('login.setPasswordAndPreferences.form.action') }
                        </Button>
                    </Col>
                </div>
            </Row>
        );
    }
}

export default connectToStores( [ FeatureFlagStore ], () => ({
    enableEmailMarketing: FeatureFlagStore.get('enableEmailMarketing'),
    enableSmsMarketing: FeatureFlagStore.get('enableSmsMarketing')
}))(SetPasswordAndPreferences);
